import Image from "../image/image";
import css from "./arrow-icon.module.scss";

export enum ArrowIconStyle {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  Tertiary = "tertiary",
  Quaternary = "quaternary",
}

export enum ArrowIconDirection {
  RIGHT = "right",
  LEFT = "left",
  UP = "up",
  DOWN = "down",
}

interface IArrowIconProps {
  className?: string;
  style?: ArrowIconStyle;
  direction?: ArrowIconDirection;
  width?: number;
  height?: number;
}

const ArrowIcon = (props: IArrowIconProps) => {
  const {
    className,
    style = ArrowIconStyle.PRIMARY,
    direction = ArrowIconDirection.RIGHT,
    width = 20,
    height = 20,
  } = props;
  return (
    <span
      className={`${css.arrowIcon} ${className} ${css[style]} ${css[direction]}`}
    >
      <Image
        className={css.arrowIconImage}
        src="/arrow.svg"
        alt="arrow icon"
        width={width}
        height={height}
      />
    </span>
  );
};

export default ArrowIcon;
